import { Component, Input, TemplateRef, ChangeDetectionStrategy } from "@angular/core";
import { ISearchResponseRow, ISearchResultRenderer } from "../../quick-search.models";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-produkt-renderer",
    templateUrl: "./produkt-renderer.component.html",
    styleUrls: ["../default-renderer.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbPopover]
})
export class ProduktRendererComponent implements ISearchResultRenderer {
    @Input() input: ISearchResponseRow;
    @Input() tooltipTemplate: TemplateRef<any>;
}
